/**
 * Application configuration
 * Centralizes all environment variables and configuration settings
 */

// API configuration
export const API_CONFIG = {
  baseURL: 'https://api.kewaar.com/api/admin',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};

// Upload configuration
export const UPLOAD_CONFIG = {
  // Upload Backend Configuration
  UPLOAD_BACKEND: process.env.VUE_APP_UPLOAD_BACKEND || 'server',
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || 'https://api.kewaar.com/api/admin',
  
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_AUDIO_TYPES: ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/ogg', 'audio/mp4', 'audio/aac', 'audio/webm'],
  ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/webm', 'video/ogg'],
  ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
};

// Authentication configuration
export const AUTH_CONFIG = {
  TOKEN_KEY: 'token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  TOKEN_EXPIRY_KEY: 'token_expiry',
};

// GPT configuration
export const GPT_CONFIG = {
  ENABLED: true, // Feature flag for GPT features
  MODEL: 'gpt-4', // The GPT model to use
  MAX_TOKENS: 2000, // Maximum tokens for GPT responses
};

// Feature flags
export const FEATURES = {
  ENABLE_BLOG: true,
  ENABLE_ASSESSMENT: true,
  ENABLE_COURSES: true,
  ENABLE_GPT: GPT_CONFIG.ENABLED,
};

// Default pagination settings
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50, 100],
};

// Application theme and UI settings
export const UI_CONFIG = {
  PRIMARY_COLOR: '#3b82f6',
  SECONDARY_COLOR: '#64748b',
  SUCCESS_COLOR: '#22c55e',
  ERROR_COLOR: '#ef4444',
  WARNING_COLOR: '#f59e0b',
  INFO_COLOR: '#3b82f6',
  SIDEBAR_WIDTH: '280px',
};

// Export all configurations as a single object
export default {
  API: API_CONFIG,
  UPLOAD: UPLOAD_CONFIG,
  AUTH: AUTH_CONFIG,
  GPT: GPT_CONFIG,
  FEATURES,
  PAGINATION,
  UI: UI_CONFIG,
}; 